import { apiClient } from './client';
import type { RequestOptions } from '@/types/api';
import type { TaskListResponse, TaskDetailResponse, TaskFilters } from '@/types/task';

/**
 * Tasks API functions for the CDN Manager
 */
export const tasksApi = {
  /**
   * Fetch tasks with optional filters
   */
  async getAll(filters?: TaskFilters, options?: RequestOptions): Promise<TaskListResponse> {
    const params: Record<string, string> = {};
    if (filters?.type) params.type = filters.type;
    if (filters?.status) params.status = filters.status;
    if (filters?.domain_id) params.domain_id = filters.domain_id;
    if (filters?.certificate_id) params.certificate_id = filters.certificate_id;
    if (filters?.limit) params.limit = String(filters.limit);
    if (filters?.offset) params.offset = String(filters.offset);

    const response = await apiClient.get<TaskListResponse>('/tasks', {
      params,
      signal: options?.signal,
    });
    return response.data;
  },

  /**
   * Fetch a task with its subtasks
   */
  async getById(id: string, options?: RequestOptions): Promise<TaskDetailResponse> {
    const response = await apiClient.get<TaskDetailResponse>(`/tasks/${id}`, {
      signal: options?.signal,
    });
    return response.data;
  },

  /**
   * Cancel a pending or running task
   */
  async cancel(id: string): Promise<{ message: string }> {
    const response = await apiClient.post<{ message: string }>(`/tasks/${id}/cancel`);
    return response.data;
  },

  /**
   * Retry the failed subtasks of a task
   */
  async retry(id: string): Promise<{ message: string }> {
    const response = await apiClient.post<{ message: string }>(`/tasks/${id}/retry`);
    return response.data;
  },
};
